import type Media from '@api/models/Media';
import { type IConfig } from '@players/types';

export function getUriFromMediaObject(mediaObject: Media, config: IConfig): string {
  const { mountPoint, mountPointHD, mp3Stream, audioAac, audioHls } = mediaObject;
  const { hdStream, userToken } = config;
  if (userToken && hdStream && mountPointHD) {
    return mountPointHD;
  }
  return mountPoint || audioHls || mp3Stream || audioAac || '';
}

export function isTritonMedia(mediaObject: Media): boolean {
  const { mountPoint, audioHls } = mediaObject;
  return !!(mountPoint || audioHls);
}

export const loadScript = (url: string): HTMLScriptElement => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
  return script;
};
